import React from 'react'
import ReactPlaceholder from 'react-placeholder'
import Placeholder from './Placeholder'
import PropTypes from 'prop-types'

const Title = props => (
  <ReactPlaceholder ready={props.ready} customPlaceholder={<Placeholder />}>
    <div className='col'>
      <h2 className='txt-title txt-font-body txt-initial color-title mr-auto'>Pedidos</h2>
    </div>
  </ReactPlaceholder>
)

Title.propTypes = {
  ready: PropTypes.bool
}
export default Title



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/Title/Title.js